<template>
  <WdsStack gap-md direction-row justify-space-between align-center>
    <WdsHeading as="div" type="title4" class="tw-mt-1">
      {{ $t('Classification:') }}
    </WdsHeading>
    <WdsLabel warning>
      {{ hireApprovable.classificationLabel }}
    </WdsLabel>
    <div>
      <WdsButton
        :href="hireApprovable.classificationPdfUrl"
        secondary
        target="_blank"
        class="text-nowrap"
      >
        {{ $t('View Document') }}
      </WdsButton>
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsHeading, WdsLabel, WdsButton } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { FragmentType, useFragment } from '@/gql/fragment-masking'
import { HireApprovableFragment } from '@/components/Workflows/Approvals/graphql/fragments'

const props = defineProps<{ approvable: FragmentType<typeof HireApprovableFragment> }>()
const hireApprovable = useFragment(HireApprovableFragment, props.approvable)
</script>
